import React, { useState } from "react";
import { connect, useDispatch } from "react-redux";
import { Link, NavLink, useNavigate, useParams } from "react-router-dom";

import bg6 from "../../images/background/bg6.jpg";
import { useEffect } from "react";
import { Spin } from "antd";
import { Button, Modal } from "react-bootstrap";
import {
  loadingToggleAction,
  login_userAction,
} from "../../store/actions/AuthActions";
import {
  POST_CompanyDetailByID,
  POST_CompanyDetailForChekLoginURL,
  POST_GetCompanyDetailByID,
} from "../helpers/url_helper";
import { post } from "../helpers/api_helper";
import { errorMessage } from "./LIMSpages/CommonFunctions";

const CustomerLogin = () => {
  const { CompanyIDParam, CompanyNameParam } = useParams();

  const [heartActive, setHeartActive] = useState(true);
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  let errorsObj = { email: "", password: "" };
  const [errors, setErrors] = useState(errorsObj);
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [showLicenceExpiryModal, setShowLicenceExpiryModal] = useState(false);
  const [licenceInfo, setLicenceInfo] = useState(null);

  const [rememberMe, setRememberMe] = useState(false);
  const [companyName, setCompanyName] = useState();
  const [companyID, setCompanyID] = useState();

  function onLogin(e) {
    e.preventDefault();
    let error = false;
    const errorObj = { ...errorsObj };

    if (email === "") {
      errorObj.email = "Username is Required";
      error = true;
    }

    if (password === "") {
      errorObj.password = "Password is Required";
      error = true;
    }

    setErrors(errorObj);
    if (error) {
      return;
    }

    setIsLoading(true);
    if (rememberMe) {
      localStorage.setItem(
        "rememberUser",
        JSON.stringify({
          username: window.btoa(email),
          password: window.btoa(password),
        })
      );
    } else {
      localStorage.removeItem("rememberUser");
    }

    dispatch(loadingToggleAction(true));

    dispatch(
      login_userAction(
        email,
        password,
        navigate,
        setIsLoading,
        setShowLicenceExpiryModal,
        setLicenceInfo,
        CompanyIDParam,
        CompanyNameParam,
        2
      )
    );
  }

  useEffect(() => {
    if (CompanyIDParam) {
      if (CompanyNameParam) {
        setCompanyName(window.atob(CompanyNameParam));
      }
      setCompanyID(window.atob(CompanyIDParam));
      getCompanyDetails();
    } else {
      getCompanyDetailForChekLoginURL();
    }

    if (localStorage.getItem("rememberUser")) {
      setRememberMe(true);
      let rememberUser = JSON.parse(localStorage.getItem("rememberUser"));
      setEmail(window.atob(rememberUser?.username));
      setPassword(window.atob(rememberUser?.password));
    }
  }, []);

  const getCompanyDetails = () => {
    setIsLoading(true);
    post(POST_CompanyDetailByID, {
      CompanyIDEncrypted: window.atob(CompanyIDParam),
    })
      .then((response) => {
        if (response?.IsSuccess == false) {
          errorMessage("Customer login link is invalid");
          setCompanyName("");
          setCompanyID("");
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getCompanyDetailForChekLoginURL = () => {
    setIsLoading(true);
    post(POST_CompanyDetailForChekLoginURL)
      .then((response) => {
        if (response?.IsSuccess == false) {
          errorMessage("Customer login link is invalid");
          setCompanyName("");
          setCompanyID("");
        } else {
          const CustomerLoginURL =
            "/customer-login/" +
            response?.CompanyList[0]?.CustomerCompanyIDEncrypt +
            "/" +
            response?.CompanyList[0]?.CustomerCompanyName;

          window.location = CustomerLoginURL;
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (email) {
      const errorObj = { ...errorsObj };
      errorsObj.email = "";
      setErrors(errorObj);
    }
    if (password) {
      const errorObj = { ...errorsObj };
      errorsObj.password = "";
      setErrors(errorObj);
    }
  }, [email, password]);

  return (
    <div className="page-wraper">
      {companyID ? (
        <div className="browse-job login-style3">
          {companyName && (
            <div className="text-center bg-primary-light">
              <label
                className="mb-0 text-primary"
                style={{
                  fontSize: `18pt`,
                }}
              >
                {companyName}
              </label>
            </div>
          )}
          <div
            className="bg-img-fix overflow-hidden"
            style={{
              background: "#fff url(" + bg6 + ")",
              // height: "100vh",
              height: "96vh",
              width: "100%",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
            }}
          >
            <div className="row gx-0">
              <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 vh-100">
                <Spin size="large" spinning={isLoading} tip={"Loading..."}>
                  <div
                    // id="mCSB_1"
                    className="mCustomScrollBox mCS-light mCSB_vertical mCSB_inside"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100vh",
                    }}
                  >
                    <div
                      id="mCSB_1_container"
                      className="mCSB_container"
                      style={{
                        position: "relative",
                        top: "0",
                        left: "0",
                        dir: "ltr",
                      }}
                    >
                      <div className="login-form style-2 m-2">
                        <div
                          className="card-body bg-white"
                          style={{ borderRadius: "5px" }}
                        >
                          <div className="logo-header">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              width="280"
                              height="40"
                              viewBox="0 0 280 40"
                            >
                              <g transform="matrix(1,0,0,1,-0.9090909090909918,0.3639303566203864)">
                                <svg
                                  viewBox="0 0 396 56"
                                  data-background-color="#ffffff"
                                  preserveAspectRatio="xMidYMid meet"
                                  height="40"
                                  width="280"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g
                                    id="tight-bounds"
                                    transform="matrix(1,0,0,1,0.2400000000000091,-0.09613254703180019)"
                                  >
                                    <svg
                                      viewBox="0 0 395.52 56.192265094063615"
                                      height="56.192265094063615"
                                      width="395.52"
                                    >
                                      <g>
                                        <svg
                                          viewBox="0 0 460.7980827579752 65.46644422828784"
                                          height="56.192265094063615"
                                          width="395.52"
                                        >
                                          <g transform="matrix(1,0,0,1,65.2780827579752,9.047822610421836)">
                                            <svg
                                              viewBox="0 0 395.52 47.37079900744417"
                                              height="47.37079900744417"
                                              width="395.52"
                                            >
                                              <g id="textblocktransform">
                                                <svg
                                                  viewBox="0 0 395.52 47.37079900744417"
                                                  height="47.37079900744417"
                                                  width="395.52"
                                                  id="textblock"
                                                >
                                                  <g>
                                                    <svg
                                                      viewBox="0 0 395.52 47.37079900744417"
                                                      height="47.37079900744417"
                                                      width="395.52"
                                                    >
                                                      <g transform="matrix(1,0,0,1,0,0)">
                                                        <svg
                                                          width="395.52"
                                                          viewBox="4.5 -35.6 307.23 36.2"
                                                          height="47.37079900744417"
                                                          data-palette-color="#556970"
                                                        >
                                                          <g
                                                            className="wordmark-text-0"
                                                            data-fill-palette-color="primary"
                                                            id="text-0"
                                                          >
                                                            <path
                                                              d="M9.25 0L4.5 0 4.5-34.9Q6.55-35.15 9.03-35.27 11.5-35.4 14.15-35.4L14.15-35.4Q18.5-35.4 21.55-34.02 24.6-32.65 26.2-30.25 27.8-27.85 27.8-24.75L27.8-24.75Q27.8-21 25.95-18.4 24.1-15.8 20.8-14.43 17.5-13.05 13.15-13.05L13.15-13.05Q11.05-13.05 9.25-13.2L9.25-13.2 9.25 0ZM13.75-17L13.75-17Q18.2-17 20.65-19 23.1-21 23.1-24.35L23.1-24.35Q23.1-27.6 20.75-29.5 18.4-31.4 14.05-31.4L14.05-31.4Q12.7-31.4 11.5-31.35 10.3-31.3 9.25-31.2L9.25-31.2 9.25-17.25Q10.05-17.15 11.2-17.07 12.35-17 13.75-17ZM58.4-1.5L53.95 0.6 49.6-8.9Q47.95-12.45 45.45-13.95 42.95-15.45 39.05-15.45L39.05-15.45 38.3-15.45 38.3 0 33.55 0 33.55-34.9Q36.2-35.15 38.62-35.27 41.05-35.4 43.8-35.4L43.8-35.4Q50.2-35.4 53.42-32.8 56.65-30.2 56.65-26.1L56.65-26.1Q56.65-22.45 54.47-20.23 52.3-18 48.2-16.9L48.2-16.9Q49.55-16.3 50.6-15.48 51.65-14.65 52.62-13.28 53.6-11.9 54.6-9.7L54.6-9.7 58.4-1.5ZM38.3-31.2L38.3-19.45 43.8-19.45Q47.4-19.45 49.65-21.05 51.9-22.65 51.9-25.65L51.9-25.65Q51.9-28.15 49.8-29.78 47.7-31.4 43.8-31.4L43.8-31.4Q42.1-31.4 40.75-31.35 39.4-31.3 38.3-31.2L38.3-31.2ZM92.8-1.25L88.45 0.5 84.55-9.5 68.34-9.5 64.45 0.4 60.4-1.25 74.09-35 79.3-35 92.8-1.25ZM76.45-30.3L69.84-13.5 83-13.5 76.45-30.3ZM109.74 0.6L109.74 0.6Q105.69 0.6 102.54-1.5 99.39-3.6 97.59-7.48 95.79-11.35 95.79-16.6L95.79-16.6Q95.79-22.2 97.69-26.48 99.59-30.75 103.17-33.18 106.74-35.6 111.79-35.6L111.79-35.6Q115.04-35.6 117.59-34.8 120.14-34 122.39-32.75L122.39-32.75 120.64-28.8Q118.54-29.95 116.37-30.7 114.19-31.45 111.54-31.45L111.54-31.45Q108.39-31.45 105.94-29.78 103.49-28.1 102.07-24.85 100.64-21.6 100.64-16.9L100.64-16.9Q100.64-12.7 101.94-9.73 103.24-6.75 105.54-5.15 107.84-3.55 110.84-3.55L110.84-3.55Q113.64-3.55 115.82-4.73 117.99-5.9 119.24-7.15L119.24-7.15 119.24-14.8 111.99-14.8 111.99-18.55 123.74-18.55 123.74 0 119.54 0 119.54-3.5Q117.79-1.95 115.29-0.68 112.79 0.6 109.74 0.6ZM144.39 0L139.64 0 139.64-13.3 127.49-33.05 131.49-35.45 142.19-17.7 152.69-35.25 156.44-33.05 144.39-13.3 144.39 0ZM189.84-1.25L185.49 0.5 181.59-9.5 165.39-9.5 161.49 0.4 157.44-1.25 171.14-35 176.34-35 189.84-1.25ZM173.49-30.3L166.89-13.5 180.04-13.5 173.49-30.3Z"
                                                              fill="#556970"
                                                              data-fill-palette-color="primary"
                                                            ></path>
                                                            <path
                                                              d="M230.14 0L209.34 0 209.34-35 214.09-35 214.09-4.25 230.14-4.25 230.14 0ZM239.64 0L234.89 0 234.89-35 239.64-35 239.64 0ZM253.13 0L248.63 0 248.63-35 255.28-35 264.98-12.85 274.53-35 281.33-35 281.33 0 276.58 0 276.58-28.95 267.23-7.9 262.53-7.9 253.13-28.95 253.13 0ZM299.03 0.6L299.03 0.6Q295.38 0.6 292.38-0.38 289.38-1.35 287.33-2.95L287.33-2.95 289.73-6.95Q291.53-5.45 293.78-4.5 296.03-3.55 299.03-3.55L299.03-3.55Q302.63-3.55 304.73-5.05 306.83-6.55 306.83-9.1L306.83-9.1Q306.83-10.55 306.23-11.68 305.63-12.8 303.91-13.88 302.18-14.95 298.83-16.2L298.83-16.2Q295.23-17.6 293.08-19.03 290.93-20.45 290.01-22.28 289.08-24.1 289.08-26.6L289.08-26.6Q289.08-29.1 290.46-31.13 291.83-33.15 294.51-34.38 297.18-35.6 300.98-35.6L300.98-35.6Q304.08-35.6 306.56-34.98 309.03-34.35 311.38-33.2L311.38-33.2 309.63-29.15Q307.93-30.15 305.66-30.83 303.38-31.5 300.88-31.5L300.88-31.5Q297.58-31.5 295.68-30.2 293.78-28.9 293.78-26.85L293.78-26.85Q293.78-25.55 294.33-24.55 294.88-23.55 296.51-22.6 298.13-21.65 301.38-20.45L301.38-20.45Q305.28-19 307.56-17.4 309.83-15.8 310.78-13.93 311.73-12.05 311.73-9.65L311.73-9.65Q311.73-6.4 310.11-4.1 308.48-1.8 305.61-0.6 302.73 0.6 299.03 0.6Z"
                                                              // fill="#b19dd0"
                                                              fill="#30bbaa"
                                                              data-fill-palette-color="secondary"
                                                            ></path>
                                                          </g>
                                                        </svg>
                                                      </g>
                                                    </svg>
                                                  </g>
                                                </svg>
                                              </g>
                                            </svg>
                                          </g>
                                          <g>
                                            <svg
                                              viewBox="0 0 54.094974011493804 65.46644422828784"
                                              height="65.46644422828784"
                                              width="54.094974011493804"
                                            >
                                              <g>
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  version="1.1"
                                                  x="0"
                                                  y="0"
                                                  viewBox="44.467 0 423.06600000000003 512"
                                                  enableBackground="new 0 0 512 512"
                                                  height="65.46644422828784"
                                                  width="54.094974011493804"
                                                  className="icon-icon-0"
                                                  data-fill-palette-color="accent"
                                                  id="icon-0"
                                                >
                                                  <g
                                                    fill="#556970"
                                                    data-fill-palette-color="accent"
                                                  >
                                                    <path
                                                      d="M256 0C139.167 0 44.467 94.708 44.467 211.533 44.467 372.184 256 512 256 512s211.533-139.816 211.533-300.467C467.533 94.708 372.833 0 256 0zM256 375.941c-90.8 0-164.4-73.6-164.4-164.408 0-90.8 73.601-164.408 164.4-164.408s164.417 73.608 164.417 164.408C420.417 302.342 346.8 375.941 256 375.941z"
                                                      fill="#556970"
                                                      data-fill-palette-color="accent"
                                                    ></path>
                                                    <path
                                                      d="M277.358 188.417v-58.884c5.425 0 9.816-4.4 9.816-9.816 0-5.417-4.392-9.817-9.816-9.817h-47.242c-5.425 0-9.816 4.4-9.816 9.817 0 5.417 4.392 9.816 9.816 9.816v58.884l-53.975 78.5c-3.083 4.1-4.908 9.2-4.908 14.716 0 13.551 10.983 24.534 24.533 24.534h115.941c13.551 0 24.533-10.983 24.533-24.534 0-5.516-1.824-10.616-4.908-14.716L277.358 188.417z"
                                                      fill="#556970"
                                                      data-fill-palette-color="accent"
                                                    ></path>
                                                  </g>
                                                </svg>
                                              </g>
                                            </svg>
                                          </g>
                                        </svg>
                                      </g>
                                      <defs></defs>
                                    </svg>
                                    <rect
                                      width="395.52"
                                      height="56.192265094063615"
                                      fill="none"
                                      stroke="none"
                                      visibility="hidden"
                                    ></rect>
                                  </g>
                                </svg>
                              </g>
                            </svg>

                            {/* <h4
                              className="form-title m-t0 text-center"
                              style={{ color: "#9b8825" }}
                            >
                              {companyName}
                            </h4> */}
                          </div>

                          <div
                            className="nav nav-tabs border-bottom-0"
                            style={{ marginTop: "-15px" }}
                          >
                            <div
                              className="tab-content w-100"
                              id="nav-tabContent"
                            >
                              <div
                                className="tab-pane fade active show"
                                id="nav-personal"
                              >
                                <form
                                  className=" dz-form pb-3"
                                  onSubmit={onLogin}
                                >
                                  <h4 className="form-title m-t0 text-center">
                                    CUSTOMER LOGIN
                                  </h4>
                                  <div className="dz-separator-outer m-b5">
                                    <div className="dz-separator bg-primary style-liner"></div>
                                  </div>
                                  <p>Enter your username and password. </p>
                                  <div className="form-group mb-2">
                                    <input
                                      //type="email"
                                      className="form-control form-control-sm"
                                      value={email}
                                      placeholder="Username"
                                      onChange={(e) => setEmail(e.target.value)}
                                    />
                                    {errors.email && (
                                      <div className="text-danger fs-12">
                                        {errors.email}
                                      </div>
                                    )}
                                  </div>
                                  <div className="form-group mb-3">
                                    <input
                                      type="password"
                                      className="form-control form-control-sm"
                                      value={password}
                                      placeholder="Password"
                                      onChange={(e) =>
                                        setPassword(e.target.value)
                                      }
                                    />
                                    {errors.password && (
                                      <div className="text-danger fs-12">
                                        {errors.password}
                                      </div>
                                    )}
                                  </div>
                                  <div className="form-group text-left mb-5">
                                    <button
                                      type="submit"
                                      // className="btn btn-primary dz-xs-flex m-r5"
                                      className="btn btn-primary btn-sm me-2"
                                    >
                                      Login
                                    </button>
                                    {/* <span className="form-check d-inline-block ms-2">
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="check1"
                                        name="example1"
                                        checked={rememberMe}
                                        onChange={(e) => {
                                          setRememberMe(e.target.checked);
                                        }}
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="check1"
                                      >
                                        Remember me
                                      </label>
                                    </span> */}
                                    {/* <div className="dz-social mt-2">
                                    <span></span>
                                    <span className="dz-social-icon dz-border dz-social-icon-lg text-white me-1">
                                      <Link to="/forgot-password/">
                                        <span className="form-label text-primary">
                                          Forgot Password?
                                        </span>
                                      </Link>
                                    </span>
                                  </div> */}
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="card-footer bg-white"
                          style={{ borderRadius: "5px" }}
                        >
                          <div className=" bottom-footer clearfix m-t10 m-b20 row text-center">
                            <div className="col-lg-12 text-center">
                              <span className="text-primary">
                                {" "}
                                © Copyright by
                                <a
                                  href="https://pragyalims.com/"
                                  target="_blank"
                                >
                                  {" "}
                                  Pragya LIMS{" "}
                                </a>{" "}
                                All rights reserved.
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Spin>
              </div>
              <Modal
                className="fade"
                show={showLicenceExpiryModal}
                onHide={setShowLicenceExpiryModal}
                // size="lg"
              >
                <Modal.Header>
                  <Modal.Title>
                    <i className="fa fa-warning"></i> License/AMC Expired Alert
                  </Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowLicenceExpiryModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <p>
                    The License/AMC for Pragya LIMS web application has expired
                    on {licenceInfo?.LicenceExpiryDate}. We request you to
                    upgrade your License/AMC.
                  </p>
                  <p>
                    Kindly contact our sales/support team to upgrade the
                    License/AMC.
                  </p>
                  {licenceInfo?.LicenceHelpNumber && (
                    <p>
                      <i className="fa fa-phone"></i>{" "}
                      {licenceInfo?.LicenceHelpNumber}
                    </p>
                  )}
                  {licenceInfo?.LicenceHelpEmail && (
                    <p>
                      <i className="fa fa-envelope"></i>{" "}
                      <a href={`mailto:${licenceInfo?.LicenceHelpEmail}`}>
                        {licenceInfo?.LicenceHelpEmail}
                      </a>
                    </p>
                  )}
                  <p>
                    You can access the application again after renewal of your
                    License/AMC.
                  </p>
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default CustomerLogin;
